export const FORM_INPUT = {
	REQUIRED: 'required',
	OPTIONAL: 'optional',
}

export const CHECKOUT_FORM_VALIDATION_ERRORS = {
	NAME_REQUIRED: 'Please enter your full name',
	PHONE_NUMBER_REQUIRED: 'Please enter a valid phone number',
	PHONE_NUMBER_REQUIRED_FOR_SMS_UPDATES: 'Please enter a valid phone number to receive SMS updates',
	PHONE_NUMBER_REQUIRED_FOR_TEXT_MSG: 'Please enter a valid phone number to receive text messages',
	EMAIL_ADDRESS_REQUIRED: 'Please enter a valid email address',
	VALID_EMAIL_ADDRESS_REQUIRED: 'Please enter a valid email address to receive email receipts',
	CONSENT_REQUIRED: 'Please agree to the privacy policy',
}
